import type { InspectResult } from './JupyterClient';

/**
 * Process-local cache of kernel ``inspect`` results, keyed by the word under
 * the cursor, so hover tooltips don't re-hit the kernel for the same symbol.
 *
 * Kept in its own CodeMirror-free module: ``clearInspectCache`` is called from
 * the app-wide ``KernelPoolProvider`` on kernel teardown, and importing it via
 * the ``@/lib/jupyter`` barrel (or from ``codeIntelligence``) would otherwise
 * pull ``@codemirror/state`` and ``@codemirror/view`` into the initial bundle
 * for users who never open the code pane — defeating the lazy code-surface
 * split. Hover/intelligence code imports the cache from here; everything that
 * only needs to *clear* it can import this module alone.
 */

export const INSPECT_CACHE_TTL_MS = 30_000;
export const INSPECT_CACHE_MAX_SIZE = 100;

export const inspectCache = new Map<string, { result: InspectResult; timestamp: number }>();

/**
 * Clear the inspect cache (useful when a kernel restarts).
 */
export function clearInspectCache(): void {
  inspectCache.clear();
}
